import http from '@services/http';
import { qs } from '@utils';
import { Search } from './interfaces';

export const fetchVICSByKeyword = (data: Search.FetchVICSByKeyword.Request): Promise<Search.FetchVICSByKeyword.Response> => {
  const query = qs.stringify(data, { arrayFormat: 'bracket' });

  return http.get(`/search/vics?${query}`);
};